import { Component } from '@angular/core';

@Component({
    selector: 'cisco-steer-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    lang : string;
    ngOnInit() {
        this.lang = localStorage.getItem('selectedLanguage');
    }
}
